import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  getClientMessage(error: Error): string {
    if (typeof navigator !== 'undefined' && !navigator.onLine) {
      return 'No Internet Connection';
    }
    return error.message ? error.message : error.toString();
  }

  getClientStack(error: Error): string {
    return error.stack || '';
  }

  getServerMessage(error: HttpErrorResponse): string {
    // Handle different error response structures
    if (error.error?.message) {
      return error.error.message;
    }
    if (error.error?.error) {
      return error.error.error;
    }
    if (error.error?.detail) {
      return error.error.detail;
    }
    if (typeof error.error === 'string') {
      return error.error;
    }
    if (error.error?.non_field_errors) {
      return Array.isArray(error.error.non_field_errors)
        ? error.error.non_field_errors.join(', ')
        : error.error.non_field_errors;
    }
    // Fallback to status text or generic message
    return error.statusText || error.message || 'An error occurred';
  }

  getServerStack(_error: HttpErrorResponse): string {
    // handle stack trace
    return 'stack';
  }
}